import { getJwtFromCookies } from '@helpers'
import { parseJwt } from './parse-jwt'

export const currentUserLang = () => {
  const jwt = getJwtFromCookies()
  if (jwt) {
    const currentUser = parseJwt(jwt)
    return currentUser ? currentUser.lang : 'es'
  }

  return 'es'
}
